export default "__VITE_ASSET__CiHoNaCV__"